
// 单科报告投屏模式
const ExamReportScreenLayout = r => require(['@/v3/modules/report/views/single/grade/screen/layout'], r)
const ExamReportScreenBasic = r => require(['@/v3/modules/report/views/single/grade/screen/basic'], r)
const ExamReportScreenAbility = r => require(['@/v3/modules/report/views/single/grade/screen/ability'], r)
const ExamReportScreenComment = r => require(['@/v3/modules/report/views/single/grade/screen/comment'], r)


export default {
  path: '/exam/single/report/screen/:id',
  meta: { auth: ['Exam-Single-Report-Grade', 'School-Report'] },
  component: ExamReportScreenLayout,
  name: 'screenGradeReport',
  redirect: '/exam/single/report/screen/basic/:id',
  children: [
    {
      path: '/exam/single/report/screen/basic/:id',
      meta: { auth: ['Exam-Single-Report-Grade', 'School-Report'] },
      component: ExamReportScreenBasic,
    },
    {
      path: '/exam/single/report/screen/comment/:id',
      meta: { auth: ['Exam-Single-Report-Grade', 'School-Report'] },
      component: ExamReportScreenComment,
    },
    {
      path: '/exam/single/report/screen/ability/:id',
      meta: { auth: ['Exam-Single-Report-Grade', 'School-Report'] },
      component: ExamReportScreenAbility,
    }
  ]
}